import React, { useEffect, useRef, useState } from "react";
import homeBanner from "../../assets/homeBannner.png";
import { CiCirclePlus } from "react-icons/ci";
import dummyProfile from "../../assets/dummyProfile.jpg";
import { useStores } from "../../stores";
import { apiPostPut, fetchFactFinderAdminUsers, apiGet } from "../../api/api_methods";
import Loader from "../reusableComponents/loader";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";
import { rolesWithId } from "../../constants/constants";

function Createnew() {
  const { clientsStore } = useStores();
  console.log(clientsStore.user.role);
  const [ptype, setPtype] = useState(true);
  const [load, setLoad] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false); // Track if submit button is clicked
  const [factFinderAdmins, setFactFinderAdmins] = useState([]);
  const [isLoadingFactFinderAdmins, setIsLoadingFactFinderAdmins] = useState(false);
  const [factFinderAdminsError, setFactFinderAdminsError] = useState("");
  const [selectedFactFinderAdminId, setSelectedFactFinderAdminId] = useState("");
  const [existingPlanners, setExistingPlanners] = useState([]);

  const [formData, setFormData] = useState({
    role: "Client",
    name: "",
    dob: "",
    pan: "",
    email: "",
    mobile: "",
    password: "",
    planType: "",
  });
  const NameOfThePlanner = useRef(null);
  const DOB = useRef(null);
  const PAN = useRef(null);
  const Email = useRef(null);
  const Mobile = useRef(null);
  const PlanType = useRef(null);

  // Fetch financial planner details from Fact Finder (GetAdminUsers)
  useEffect(() => {
    const isSuperAdmin = clientsStore.user.role === "6720e9760ca50db671add43c";
    if (!isSuperAdmin || formData.role !== "Financial Planner") {
      return;
    }

    const loadAdmins = async () => {
      try {
        setIsLoadingFactFinderAdmins(true);
        setFactFinderAdminsError("");
        const response = await fetchFactFinderAdminUsers(1, 20);

        if (response.status === 200 && response.body) {
          // Try a few common shapes for the data
          const raw =
            response.body.data ||
            response.body.users ||
            response.body.items ||
            response.body.result ||
            response.body;

          const list = Array.isArray(raw)
            ? raw
            : Array.isArray(raw?.adminUsers)
            ? raw.adminUsers
            : [];

          setFactFinderAdmins(list);
        } else {
          setFactFinderAdmins([]);
          setFactFinderAdminsError(
            response.body?.message ||
              "Unable to load financial planner list from Fact Finder"
          );
        }
      } catch (error) {
        console.error("Error fetching Fact Finder admin users:", error);
        setFactFinderAdmins([]);
        setFactFinderAdminsError(
          "Error fetching financial planner list from Fact Finder"
        );
      } finally {
        setIsLoadingFactFinderAdmins(false);
      }
    };

    // Load only once per Financial Planner view
    if (factFinderAdmins.length === 0 && !isLoadingFactFinderAdmins) {
      loadAdmins();
    }
  }, [
    clientsStore.user.role,
    formData.role,
    factFinderAdmins.length,
    isLoadingFactFinderAdmins,
  ]);

  // Fetch existing Financial Planners from Awaken (to detect duplicates)
  useEffect(() => {
    const isSuperAdmin = clientsStore.user.role === "6720e9760ca50db671add43c";
    if (!isSuperAdmin || formData.role !== "Financial Planner") {
      return;
    }

    const fetchExistingPlanners = async () => {
      try {
        const agentRoleId = rolesWithId.agent || "6720e9990ca50db671add43e";
        const apiResponse = await apiGet(`/users/get-users?role=${agentRoleId}`);
        if (apiResponse.status === 200) {
          const planners =
            apiResponse.body.data?.users || apiResponse.body.users || [];
          setExistingPlanners(Array.isArray(planners) ? planners : []);
        } else {
          console.error("Failed to fetch existing financial planners");
        }
      } catch (error) {
        console.error("Error fetching existing financial planners:", error);
      }
    };

    if (existingPlanners.length === 0) {
      fetchExistingPlanners();
    }
  }, [clientsStore.user.role, formData.role, existingPlanners.length]);

  const handleChange = (e) => {
    var { name, value } = e.target;
    if (name === "name") {
      value = value.replace(/\b\w/g, (char) => char.toUpperCase());
    }
    if (name === "pan") {
      value = value.toUpperCase();
      if (value.length > 10) {
        return;
      }
    }
    if (name === "mobile") {
      if (isNaN(value)) {
        return;
      }
      if (value.length > 10) {
        return;
      }
    }
    setFormData({ ...formData, [name]: value });
    // Clear the error message when the input changes
    setErrors({ ...errors, [name]: "" });
  };

  // When a Fact Finder financial planner is selected from the dropdown,
  // auto-fill the local Financial Planner form fields.
  const handleSelectFactFinderAdmin = (e) => {
    const value = e.target.value;
    setSelectedFactFinderAdminId(value);

    if (!value) return;

    const selected =
      factFinderAdmins.find(
        (admin) =>
          String(admin.id) === value ||
          String(admin.userId) === value ||
          String(admin.userID) === value
      ) || null;

    if (!selected) return;

    const name =
      selected.name ||
      selected.fullName ||
      selected.userName ||
      selected.username ||
      "";
    const email =
      selected.email ||
      selected.mailId ||
      selected.userEmail ||
      selected.contactEmail ||
      "";
    const mobile =
      selected.mobileNumber ||
      selected.mobile ||
      selected.phoneNumber ||
      selected.phone ||
      "";

    setFormData((prev) => ({
      ...prev,
      name: name || prev.name,
      email: email || prev.email,
      mobile: mobile || prev.mobile,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (formData.role === "Financial Planner") {
      // No PAN or Aadhaar required for Financial Planner
      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Invalid email format";
      }
      if (!formData.mobile.trim()) {
        newErrors.mobile = "Mobile number is required";
      } else if (formData.mobile.length !== 10) {
        newErrors.mobile = "Mobile number must be 10 digits";
      }
      if (!formData.password.trim()) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      }
    } else if (formData.role === "Client") {
      if (!formData.pan.trim()) {
        newErrors.pan = "PAN number is required";
      } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan)) {
        newErrors.pan =
          "Invalid PAN format. Must be 5 letters, 4 digits, and 1 letter.";
      }
      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Invalid email format";
      }
      if (!formData.mobile.trim()) {
        newErrors.mobile = "Mobile number is required";
      } else if (formData.mobile.length !== 10) {
        newErrors.mobile = "Mobile number must be 10 digits";
      }
      if (!formData.dob.trim()) {
        newErrors.dob = "Date of birth is required";
      }
      if (!formData.planType) {
        newErrors.planType = "Plan type is required";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitAttempted(true); // set to true to show the error messages on the submit button
    const isValid = validateForm();
    if (!isValid) {
      setIsSubmitting(false);
      return;
    }

    if (formData.role === "Financial Planner") {
      // Check if a financial planner with same email or mobile already exists
      const emailLower = formData.email.trim().toLowerCase();
      const mobile = formData.mobile.trim();

      const duplicatePlanner = existingPlanners.find((planner) => {
        const plannerEmail = (planner.email || "").toLowerCase();
        const plannerMobile =
          planner.mobileNumber || planner.mobile || planner.phoneNumber || "";
        return (
          (emailLower && plannerEmail === emailLower) ||
          (mobile && plannerMobile === mobile)
        );
      });

      if (duplicatePlanner) {
        const name = duplicatePlanner.name || duplicatePlanner.fullName || "";
        alert(
          `Financial planner already exists${
            name ? `: ${name}` : ""
          }. Please use the existing planner instead of creating a duplicate.`
        );
        setIsSubmitting(false);
        return;
      }

      setLoad(true);
      let body = {};
      for (const key in formData) {
        if (
          formData[key] !== "" &&
          formData[key] !== null &&
          formData[key] !== undefined &&
          key !== "role"
        ) {
          // Map field names to match backend expectations
          if (key === "mobile") {
            body["mobileNumber"] = formData[key];
          } else {
            body[key] = formData[key];
          }
        }
      }
      body["userId"] = clientsStore.user._id;
      body["role"] = "6720e9990ca50db671add43e"; // Agent role ID for Financial Planner
      const apiResponse = await apiPostPut(body, "/users/create-user", "POST");
      if (apiResponse.status === 200) {
        alert("Financial planner created successfully");
        setLoad(false);
        setFormData({
          role: "Financial Planner",
          name: "",
          dob: "",
          pan: "",
          email: "",
          mobile: "",
          password: "",
          planType: "",
        });
      } else {
        apiResponse.body.message && alert(apiResponse.body.message);
        console.log("Error in creating financial planner");
        setLoad(false);
      }
    } else if (formData.role === "Client") {
      let body = {};
      for (const key in formData) {
        if (
          formData[key] !== "" &&
          formData[key] !== null &&
          formData[key] !== undefined &&
          key !== "role"
        ) {
          // Map field names to match backend expectations
          if (key === "mobile") {
            body["mobileNumber"] = formData[key];
          } else {
            body[key] = formData[key];
          }
        }
      }
      // Remove userId from client creation - it might be causing "client already exists" error
      // body["userId"] = clientsStore.user._id;
      body["role"] = clientsStore.user.role;

      // Ensure PAN is sent with both possible field names
      if (formData.pan) {
        body["pan"] = formData.pan;
        // body["panNumber"] = formData.pan; // Try both field names
      }

      // Debug logging
      console.log("Form Data:", formData);
      console.log("Request Body:", body);
      console.log("PAN in formData:", formData.pan);
      console.log("PAN in body:", body.pan);
      console.log("PAN Number in body:", body.panNumber);

      const apiResponse = await apiPostPut(
        body,
        "/adminPanel/create-client",
        "POST"
      );

      // Debug API response
      console.log("API Response:", apiResponse);

      if (apiResponse.status === 200) {
        // Check if the current user is a financial planner (agent)
        const currentUser = clientsStore.user;
        const isFinancialPlanner = currentUser.role === rolesWithId.agent;
        
        // Get the formId from the response
        const formId = apiResponse.body?.data?._id || apiResponse.body?._id || apiResponse.body?.formId;
        
        // If the creator is a financial planner, automatically assign the client to themselves
        if (isFinancialPlanner && formId && currentUser._id) {
          try {
            const assignBody = {
              formId: formId,
              agentId: currentUser._id,
            };
            
            const assignResponse = await apiPostPut(
              assignBody,
              "/adminPanel/assign-client",
              "PUT"
            );
            
            if (assignResponse.status === 200) {
              console.log("Client automatically assigned to creator");
            } else {
              console.warn("Failed to auto-assign client to creator:", assignResponse?.body?.message);
              // Don't fail the client creation if assignment fails
            }
          } catch (error) {
            console.error("Error auto-assigning client to creator:", error);
            // Don't fail the client creation if assignment fails
          }
        }
        
        alert("Client created successfully");
        setLoad(false);
        setFormData({
          role: "Client",
          name: "",
          dob: "",
          pan: "",
          email: "",
          mobile: "",
          password: "",
          planType: "",
        });
      } else {
        apiResponse.body.message && alert(apiResponse.body.message);
        console.log("Error in creating client");
        setLoad(false);
      }
    } else {
      alert("Please select a role");
      setLoad(false);
    }

    setIsSubmitting(false);
    setSubmitAttempted(false);
  };

  function toTileCase(str) {
    if (str === null || str === "" || str === undefined) return "";
    return str
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  }

  function formatDate(date) {
    if (date === null || date === "" || date === undefined) return "";
    var dateArray = date.split("-");
    return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
  }

  return (
    <div className="relative w-full flex flex-col items-center justify-center">
      <Loader loader={load} text={""} />
      <img
        src={homeBanner}
        alt="homeBanner"
        className="mt-0 h-[25vh] object-cover object-center w-full"
      />
      <div className="absolute border-2 rounded-lg bg-white top-[50%] pl-5 py-5">
        <p className="p-6 pb-3 flex flex-row items-center gap-3 font-semibold text-2xl">
          <span className="bg-green-500 flex items-center justify-center w-9 h-9 rounded-full">
            <CiCirclePlus className="text-white text-3xl " />
          </span>
          Create New
        </p>
        <div className=" flex items-center justify-center">
          <div className="bg-white  p-6 flex flex-col w-full">
            <form className="" onSubmit={handleSubmit}>
              <div className="flex w-full">
                <div className=" border-r-2 border-dashed border-blue-400 pr-7">
                  <div className="flex items-center gap-10 mb-5">
                    {clientsStore.user.role === "6720e9760ca50db671add43c" && (
                      <label className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="role"
                          value="Financial Planner"
                          checked={formData.role === "Financial Planner"}
                          onChange={handleChange}
                          className="text-blue-500"
                        />
                        <span className="text-sm font-medium">
                          Financial Planner
                        </span>
                      </label>
                    )}

                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="role"
                        value="Client"
                        checked={formData.role === "Client"}
                        onChange={handleChange}
                        className="text-blue-500"
                      />
                      <span className="text-sm font-medium">Client</span>
                    </label>
                  </div>
                  {formData.role === "Financial Planner" ? (
                    <>
                      {/* Dropdown to fetch Financial Planner details from Fact Finder (GetAdminUsers) */}
                      <div className="mb-6">
                        <label className="block text-xs font-medium text-gray-400 mb-2">
                          Select Financial Planner (Fact Finder)
                        </label>
                        <select
                          value={selectedFactFinderAdminId}
                          onChange={handleSelectFactFinderAdmin}
                          className="border border-gray-300 rounded-md px-2 w-72 h-8"
                        >
                          <option value="">
                            {isLoadingFactFinderAdmins
                              ? "Loading planners..."
                              : "Select from Fact Finder (optional)"}
                          </option>
                          {factFinderAdmins.map((admin) => {
                            const id =
                              admin.id ?? admin.userId ?? admin.userID ?? "";
                            const name =
                              admin.name ||
                              admin.fullName ||
                              admin.userName ||
                              admin.username ||
                              "Unnamed";

                            return (
                              <option key={id || name} value={String(id || name)}>
                                {name}
                              </option>
                            );
                          })}
                        </select>
                        {factFinderAdminsError && (
                          <p className="text-red-500 text-xs italic mt-1">
                            {factFinderAdminsError}
                          </p>
                        )}
                      </div>

                      <div className="flex flex-row gap-6 mb-6">
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Name of the Planner{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            ref={NameOfThePlanner}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.name
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.name && (
                            <p className="text-red-500 text-xs italic">
                              {errors.name}
                            </p>
                          )}
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Date of birth
                          </label>
                          <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            ref={DOB}
                            className=" border border-gray-300 rounded-md p-2 w-72 h-8"
                          />
                        </div>
                      </div>

                      <div className="flex flex-row gap-6 mb-6">
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            E-mail ID{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            ref={Email}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.email
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.email && (
                            <p className="text-red-500 text-xs italic">
                              {errors.email}
                            </p>
                          )}
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Mobile number{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            ref={Mobile}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.mobile
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.mobile && (
                            <p className="text-red-500 text-xs italic">
                              {errors.mobile}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-row gap-6 mb-6">
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Password{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <div
                            className={` border border-gray-300 rounded-md p-2 w-72 h-8 flex items-center justify-between ${
                              submitAttempted && errors.password
                                ? "border-red-500"
                                : ""
                            }`}
                          >
                            <input
                              type={ptype ? "password" : "text"}
                              name="password"
                              value={formData.password}
                              onChange={handleChange}
                              className="border-none outline-none"
                            />
                            <button
                              onClick={(e) => {
                                setPtype(!ptype);
                                e.preventDefault();
                              }}
                              className="text-blue-400"
                            >
                              {ptype ? <FaEyeSlash /> : <FaRegEye />}
                            </button>
                          </div>
                          {submitAttempted && errors.password && (
                            <p className="text-red-500 text-xs italic">
                              {errors.password}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-row gap-6 mb-6">
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Name of the Client{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            ref={NameOfThePlanner}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.name
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.name && (
                            <p className="text-red-500 text-xs italic">
                              {errors.name}
                            </p>
                          )}
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Date of birth{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            ref={DOB}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.dob
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.dob && (
                            <p className="text-red-500 text-xs italic">
                              {errors.dob}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-row gap-6 mb-6">
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Mobile number{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            ref={Mobile}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.mobile
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.mobile && (
                            <p className="text-red-500 text-xs italic">
                              {errors.mobile}
                            </p>
                          )}
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            E-mail ID{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            ref={Email}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.email
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.email && (
                            <p className="text-red-500 text-xs italic">
                              {errors.email}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-row gap-6 mb-6">
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            PAN number{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <input
                            type="text"
                            name="pan"
                            value={formData.pan}
                            onChange={handleChange}
                            ref={PAN}
                            className={`border border-gray-300 rounded-md p-2 w-72 h-8 ${
                              submitAttempted && errors.pan
                                ? "border-red-500"
                                : ""
                            }`}
                          />
                          {submitAttempted && errors.pan && (
                            <p className="text-red-500 text-xs italic">
                              {errors.pan}
                            </p>
                          )}
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-400 mb-2">
                            Plan Type{" "}
                            <span className="text-red-500 text-md">*</span>
                          </label>
                          <select
                            name="planType"
                            id="planType"
                            value={formData.planType}
                            onChange={handleChange}
                            ref={PlanType}
                            className={`border border-gray-300 rounded-md px-2 w-72 h-8 ${
                              submitAttempted && errors.planType
                                ? "border-red-500"
                                : ""
                            }`}
                          >
                            <option value="">Select Plan type</option>
                            <option value="zeroToOne">Zero2One</option>
                            <option value="basic">Basic</option>
                            <option value="comprehensive">Comprehensive</option>
                            <option value="wealthManagement">
                              Wealth
                            </option>
                          </select>
                          {submitAttempted && errors.planType && (
                            <p className="text-red-500 text-xs italic">
                              {errors.planType}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <button
                    type="submit"
                    className={`bg-blue-500 text-white py-1 px-4 float-right rounded-md hover:bg-blue-600 mb-2 ${
                      isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Save Details"}
                  </button>
                </div>

                <div
                  className="w-72 h-80 flex flex-col items-center justify-center shadow-black/30 bg-white
                   shadow-lg rounded-lg m-5 z-30"
                >
                  <div className="flex flex-col items-center justify-center p-6">
                    <div className="w-24 h-24  rounded-full overflow-hidden mb-2">
                      <img
                        src={dummyProfile}
                        alt="dummyProfile"
                        className="w-full h-full object-fill"
                      />
                    </div>
                    <h3 className="text-lg font-semibold mb-1">
                      {NameOfThePlanner.current?.value || ""}
                    </h3>
                    <p className="text-sm text-gray-500">
                      +91 {Mobile.current?.value || ""}
                    </p>
                    <p className="text-sm text-gray-500 mb-2">
                      {Email.current?.value || ""}
                    </p>
                    <p className="text-sm text-gray-500">
                      Date of Birth: {formatDate(DOB.current?.value) || ""}
                    </p>
                    <p className="text-sm text-gray-500">
                      {formData.role === "Client"
                        ? `Plan Type: ${
                            toTileCase(PlanType.current?.value) || ""
                          }`
                        : ""}
                    </p>
                    <p className="text-sm text-gray-500">
                      {formData.role === "Client"
                        ? `PAN: ${PAN.current?.value || formData.pan || ""}`
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Createnew;
